import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmComponent } from 'src/app/components/shared/components/confirm/confirm.component';
import {
  Estados,
  economicActivity,
} from 'src/app/modules/cases/components/create-case/ras-form/ras-form.utils';

enum Texts {
  businessName = '29.Razón social *',
  rif = '30.Registro de información fiscal (RIF) *',
  constitutionDate = '33.Fecha de constitución',
  economicActivity = '31.Actividad economica *',
  specificActivity = '32.Actividad especifica *',
  direction = '34.Dirección *',
  state = '35.Estado *',
  municipality = '36.Municipio *',
  parish = '37.Parroquia *',
  phone1 = '38.Telefono 1 *',
  phone2 = '39.Telefono 2',
  institutionReportingClient = '40.Cliente de la institución reportante *',
  riskLevel = '41.Nivel de riesgo LC/FT/FPADM *',
}

@Component({
  selector: 'legal-form',
  templateUrl: './legal-form.component.html',
  styleUrls: ['./legal-form.component.scss'],
})
export class LegalFormComponent implements OnInit {
  public Texts = Texts;
  @Input() form: FormGroup;
  @Input() est: any[];
  @Input() estMun: any[];
  @Input() mun: any[];
  @Input() munParr: any[];
  @Input() parr: any[];
  @Output() formChange = new EventEmitter<FormGroup>();
  economicActivity = economicActivity;
  estados = Estados;

  constructor(private readonly dialog: MatDialog) {}

  ngOnInit() {
    console.log(this.form);
  }

  riskLevels = [
    {
      name: 'Bajo',
      level: 'low',
    },
    {
      name: 'Moderado',
      level: 'moderate',
    },
    {
      name: 'Alto',
      level: 'high',
    },
  ];

  async confirmChanges() {
    this.dialog
      .open(ConfirmComponent, {
        data: {
          title:
            'Al alterar este dato, cambiara automáticamente información sensible ¿Esta seguro?',
        },
        minWidth: '400px',
      })
      .afterClosed()
      .subscribe(async (re) => {});
  }

  //cuando cambia el estado de el estado borra municipio y parroquia
  changeEstado(estad) {
    this.form.controls.municipality.setValue(undefined);
    this.form.controls.parish.setValue(undefined);
    this.mun = [];
    this.estMun = this.estados.filter((es) => {
      return es.estado == estad;
    });
    for (let e of this.estMun[0].municipio) {
      this.mun.push(e.municipio);
    }
  }
  //cuando cambia el estado de el municipio actualiza la tabla de parroquia
  changeMunicipio(mun) {
    if (this.estMun[0]) {
      this.munParr = this.estMun[0].municipio.filter((munici) => {
        return munici.municipio == mun;
      });
      this.parr = this.munParr[0].parroquias;
    }
  }
}
